import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const GoogleSearchDisplayGate = React.lazy(
  () => import("./GoogleSearchDisplay.gate")
);

const GoogleSearchDisplayLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <GoogleSearchDisplayGate />
  </React.Suspense>
);
export default () => <GoogleSearchDisplayLoadable />;
